import { isPanoramaQueryKey } from './constants';

/**
 * Removes every Panorama-owned query param (filter/column/pagination/sort,
 * including ephemeral-marked ones) and any explicitly supplied scope-local
 * params from a search string, preserving all other params (OAuth `code`/`state`,
 * `po_id`, etc.).
 *
 * Used at a region/season scope change: those params are scoped to the previous
 * region+season, so carrying them into the new scope's URL would apply — and,
 * via the persistence writer, cache — the wrong filters. Stripping them lets the
 * gate restore the new scope's own saved state instead.
 */
export const stripPersistableSearch = (
  search: string,
  scopeLocalParams: string[] = []
): string => {
  const params = new URLSearchParams(search);
  const kept = new URLSearchParams();

  for (const [key, value] of params) {
    if (!isPanoramaQueryKey(key) && !scopeLocalParams.includes(key)) {
      kept.append(key, value);
    }
  }

  const next = kept.toString();
  return next ? `?${next}` : '';
};
